module.exports = __webpack_public_path__ + "img/2.42d694e3.jpg";